export const GeneralSettingKeys = [
  'shortcuts',
  'appearance',
  'about',
  'plans',
  'billing',
  'experimental-features',
  'editor',
] as const;

export const WorkspaceSubTabs = [
  'workspace:preference',
  'workspace:properties',
  'workspace:wiki',
] as const;

export type GeneralSettingKey = (typeof GeneralSettingKeys)[number];

export type WorkspaceSubTab = (typeof WorkspaceSubTabs)[number];

export const isWorkspaceSubTab = (tab: string): tab is WorkspaceSubTab =>
  tab.startsWith('workspace:');

export type ActiveTab = GeneralSettingKey | 'account' | WorkspaceSubTab;
